// src/firebaseConfig.js


import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN?.trim()
  || 'fincontrol-3b9fa.firebaseapp.com';
/*
const firebaseConfig = {
 apiKey: "YOUR_API_KEY",
  authDomain: "YOUR_AUTH_DOMAIN",
  databaseURL: "YOUR_DATABASE_URL",
  projectId: "YOUR_PROJECT_ID",
  storageBucket: "YOUR_STORAGE_BUCKET",
  messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
  appId: "YOUR_APP_ID"
  
};
*/
export const firebaseConfig = {
    apiKey: "AIzaSyC1DegxDNN099jZjsnN2YBWZuE6u_gG16Y",
    authDomain: firebaseAuthDomain,
    databaseURL: "https://fincontrol-3b9fa-default-rtdb.firebaseio.com",
    projectId: "fincontrol-3b9fa",
    storageBucket: "fincontrol-3b9fa.appspot.com",
    messagingSenderId: "521919064536",
    appId: "1:521919064536:web:7662b273b48cbcbdebeaad"
  };
// Initialize Firebase


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const realtimeDb = getDatabase(app);
const functions = getFunctions(app, 'southamerica-east1');
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({ prompt: 'select_account' });

// Alias temporário para módulos legados do Realtime Database.
const db = realtimeDb;

export { app, auth, db, firestore, functions, googleProvider, realtimeDb };
